// import i18n from '@/i18n';
//存放数据
const state = {
  loading: false,
  // comparisonMode: "",//编辑模式
  // ComparisonList: {
  //   sourceStr: '',
  //   targetStr: '',
  //   convertStr: '',
  //   state: false,
  //   endSectionIndex: null,
  //   ifOnlyPreview: null,
  //   ifRepeatLock: null,
  //   startSectionIndex: null,
  // },//对照数据
  fragmentSentenceMt: {}, // 右侧机翻结果存储
  evaluationResults: {}, // 评价结果
  editordataList: new Map(),//存储的编辑句子数据
  currentViewMode: {},
  importOption: [], //导出选项
  temporaryTermList: [],//临时术语表
  urlInfo: {},
  projectInfo: {},
  fileInfo: {},
  fileTsakInfo: {},
  fileTsakInfo2: {},
  QAList: [],          // 底部qa列表
  suggestRemarks: false,
  setPreviewInfo: {},
  setthird: false,
  setSentCountInfo: {},     // 改变的句子
  wordPreview: {         //原译文预览页数
    partIndex: 0
  },
  setAppointPreview: {},   //指定段落数据
  taskProgress: 0,
  EleStatus: true,//检索高亮状态
  fragmentQAInfo: {},
  taskContentList: {},
  revokeData: new Map(),      //撤销数据
  recoveryData: new Map(),    //恢复数据
  cursorPositionInfo: {},      //记录光标位置
  cursorPositionTargetInfo: {},//记录光标译文位置
  updata: true,
  mymessageList: [],//获取我的消息列表
  messagestatus: false,//获取取消邀请状态
  isRecord: true,
  resetObserver: false,
  isSourceedit: false,
  sourceedit: true,//原文编辑
  targetedit: true,//译文编辑
  taskContentListParams: {
    row: 50,
    startSort: 1,
  },
  editorRightShown: {},
  currentSentenceId: {},
  tempSentence: {},
  visible: false, //弹出控制键
  updataFragmentType: 1, //片段的更新类型
  position: {
    top: 0,
    left: 0,
  },
  getTaskContentList: {},
  sourcePreviewParams: {},
  filePreviewContent: {
    sourceStr: '',
    convertStr: '',
    state: false
  },
  modifyRecord: {
    result: [],
    state: false,
  },
  modifyRecordParams: {
    partIndex: 1
  },
  previewParams: {
    partIndex: 1
  },
  editorMode: null,
  editorFontSize: '12px',
  themeInfo: 'standard',
  searchInfo: '1',
  QAState: false,
  fragmentMemory: {},
  fragmentTerm: {},
  currentRemarks: [],
  translateDictionary: [],
  suggestActiveName: 'first',
  editorBottomActiveName: 'first',
  userInfo: {},
  theme: [{
    value: 'standard',
    label: '普通模式'
  }, {
    value: 'dark',
    label: '夜间模式',
  }, {
    value: 'eye-protection',
    label: '护眼模式'
  }],
  fontSetting:
    [
      {
        value: '选项1',
        label: '粗体'
      }, {
        value: '选项2',
        label: '斜体'
      }, {
        value: '选项3',
        label: '下划线'
      }, {
        value: '选项4',
        label: '删除线'
      }
    ],
  fontSize:
  {
    12: '12px',
    14: '14px',
    16: '16px',
    18: '18px',
    20: '20px'
  }
  ,
  screenOptions: {
    options: [{
      value: '',
      label: '全部'
    },
    {
      value: '2',
      label: '译文空',
    }, {
      value: '1',
      label: '已确认',
    }, {
      value: '0',
      label: '未确认'
    }],
    options2:
      [{
        value: '',
        label: '全部'
      }, {
        value: '1',
        label: '带备注字段',
      }, {
        value: '0',
        label: '不带备注字段'
      }],
    options3:
      [{
        value: '',
        label: '全部'
      }, {
        value: '1',
        label: '已锁定',
      }, {
        value: '0',
        label: '未锁定'
      }],
  },
  countTargetIsnullIdList: [],
};
export default state
